(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const hover = matchMedia('(hover: hover) and (pointer: fine)');
  if (reduced.matches || !hover.matches) return;
  document.querySelectorAll('.neya-hero__visual').forEach(panel => {
    let frame;
    const reset = () => {
      cancelAnimationFrame(frame);
      panel.style.setProperty('--neya-tilt-x', '0deg');
      panel.style.setProperty('--neya-tilt-y', '0deg');
    };
    panel.addEventListener('pointermove', event => {
      if (reduced.matches) return;
      const bounds = panel.getBoundingClientRect();
      const x = Math.max(-1, Math.min(1, (event.clientX - bounds.left) / bounds.width * 2 - 1));
      const y = Math.max(-1, Math.min(1, (event.clientY - bounds.top) / bounds.height * 2 - 1));
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        panel.style.setProperty('--neya-tilt-x', `${-y * 2}deg`);
        panel.style.setProperty('--neya-tilt-y', `${x * 2}deg`);
      });
    }, {passive:true});
    panel.addEventListener('pointerleave', reset);
    reduced.addEventListener('change', reset);
  });
})();
